<script>
/**
 * @file 课程
 */
import Footer from './footer.vue';

export default {
    components: {
        Footer
    }
}
</script>

<template lang="pug">
.forkiss-classes-container
    router-view
    Footer(activeId="classes")
</template>

<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/components/classes.vue